import type { ReactElement } from 'react'
import { Link, NavLink } from 'react-router'
import LanguageToggle from './LanguageToggle'
import { useT } from '../i18n/useI18n'
import './Navbar.css'

export default function Navbar(): ReactElement {
  const t = useT()

  return (
    <nav className="navbar navbar-expand-lg navbar-dark navbar-soft">
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img src="/logo.svg" alt="StructuraMatrix" className="navbar-logo" />
          <span className="brand-text">
            Structura<span className="brand-highlight">Matrix</span>
          </span>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#smNavbar"
          aria-controls="smNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="smNavbar">
          <ul className="navbar-nav ms-auto align-items-lg-center">
            <li className="nav-item">
              <NavLink end className="nav-link" to="/">
                {t('nav.home')}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/products">
                {t('nav.products')}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/partners">
                {t('nav.partners')}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/about">
                {t('nav.about')}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/contact">
                {t('nav.contact')}
              </NavLink>
            </li>
            <li className="nav-item ms-lg-3 mt-2 mt-lg-0">
              <LanguageToggle />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
